import { useState, useEffect } from 'react';
import Button from '../../../components/base/Button';

const WebdesignHero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    
    // Auto-play video on mobile devices
    const handleUserInteraction = () => {
      const iframe = document.querySelector('#webdesign-hero-video') as HTMLIFrameElement;
      if (iframe) {
        iframe.src = iframe.src.replace('autoplay=1', 'autoplay=1');
      }
      document.removeEventListener('touchstart', handleUserInteraction);
      document.removeEventListener('click', handleUserInteraction);
    };

    document.addEventListener('touchstart', handleUserInteraction);
    document.addEventListener('click', handleUserInteraction);

    return () => {
      document.removeEventListener('touchstart', handleUserInteraction);
      document.removeEventListener('click', handleUserInteraction);
    };
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Video Background */}
      <div className="absolute inset-0 w-full h-full z-0 opacity-40">
        <iframe 
          id="webdesign-hero-video"
          src="https://player.vimeo.com/video/1131978174?badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1&loop=1&muted=1&background=1&controls=0&playsinline=1&title=0&byline=0&portrait=0" 
          frameBorder="0" 
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" 
          referrerPolicy="strict-origin-when-cross-origin" 
          className="absolute top-1/2 left-1/2 w-screen h-screen min-w-full min-h-full transform -translate-x-1/2 -translate-y-1/2"
          style={{ 
            width: 'max(100vw, 177.78vh)',
            height: 'max(100vh, 56.25vw)'
          }}
          title=""
        ></iframe>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 text-center text-white">
        <div className={`max-w-5xl mx-auto transition-all duration-1000 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          <div className="flex items-center justify-center space-x-3 mb-8">
            <div className="w-2 h-2 bg-[#d1bc8a] rounded-full"></div>
            <span className="text-sm uppercase tracking-[0.3em] text-gray-400 font-light">Webdesign & Entwicklung</span>
          </div>
          
          <h1 className="text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-bold text-white mb-8 leading-[1.1] tracking-tight">
            Websites, die Ihre Kunden
            <br />
            <span className="text-[#d1bc8a]">
              begeistern & verkaufen
            </span>
          </h1>
          
          <p className="text-lg md:text-xl text-gray-400 mb-12 max-w-2xl mx-auto leading-relaxed font-light">
            Moderne, responsive Websites und Online-Shops, die Ihre Kunden begeistern. 
            Von der ersten Idee bis zur fertigen Website - alles aus einer Hand.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <Button
              onClick={() => {
                const portfolioSection = document.getElementById('portfolio');
                if (portfolioSection) {
                  portfolioSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              variant="outline"
              className="px-10 py-4 border border-white text-white font-medium rounded-none hover:bg-white hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap text-sm tracking-wider uppercase"
            >
              Portfolio ansehen
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 text-[#d1bc8a] animate-bounce">
        <i className="ri-arrow-down-line text-3xl"></i>
      </div>
    </section>
  );
};

export default WebdesignHero;